import React from 'react';

import { PromoListMobileSkeleton } from '@atlas/ui';

const PromotionListSkeleton = ({ children, loading }) => {
  if (loading) {
    return <PromoListMobileSkeleton count={3} />;
  }

  return children;
};

export default PromotionListSkeleton;
